import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-garantias',
  templateUrl: './garantias.component.html',
  styleUrls: ['./garantias.component.scss']
})
export class GarantiasComponent {

  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
